import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { useLang } from "@/i18n";
import { BrandLogo } from "./Logo";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/REFORMAS+Y+ELECTRICIDAD+MARTINEZD/@39.581048,-0.3247342,17z/data=!3m1!4b1!4m6!3m5!1s0xd60414d45cfab11:0x374a61de1a234be9!8m2!3d39.581048!4d-0.3247342!9m1!1b1!16s%2Fg%2F11z4xnk2x4";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-charcoal text-stone-400">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <BrandLogo dark />
            <p className="mt-6 max-w-sm text-sm leading-relaxed">{t.footer.tagline}</p>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-stone-500">
              39.581048°N · 0.324734°W
            </p>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta">
              {t.footer.contact}
            </h3>
            <ul className="mt-6 space-y-4 text-sm">
              <li>
                <a data-testid="footer-phone-link" href="tel:+34622669378" className="flex items-center gap-3 transition-colors hover:text-terracotta">
                  <Phone size={14} className="text-terracotta" /> +34 622 66 93 78
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href="mailto:martinezamd95@gmail.com" className="flex items-center gap-3 transition-colors hover:text-terracotta">
                  <Mail size={14} className="text-terracotta" /> martinezamd95@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="mt-1 shrink-0 text-terracotta" />
                <span data-testid="footer-address">
                  Calle Avilés 3, La Pobla de Farnals (46139), Valencia
                </span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta">
              {t.footer.hours}
            </h3>
            <p className="mt-6 flex items-center gap-3 text-sm">
              <Clock size={14} className="text-terracotta" /> {t.footer.hoursValue}
            </p>
            <h3 className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta">
              {t.footer.area}
            </h3>
            <p className="mt-4 text-sm">{t.footer.areaValue}</p>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 lg:flex-row lg:items-center lg:justify-between">
          <p data-testid="footer-legal">{t.footer.legal}</p>
          <div className="flex flex-wrap items-center gap-4">
            <p>© 2026 Obras Martinez · {t.footer.rights}</p>
            <a
              data-testid="footer-review-btn"
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 border border-terracotta/60 px-3 py-1.5 text-terracotta transition-colors duration-300 hover:bg-terracotta hover:text-bone"
            >
              <Star size={11} /> {t.footer.review}
            </a>
            <Link
              data-testid="footer-admin-link"
              to="/admin"
              className="border border-white/15 px-3 py-1.5 transition-colors hover:border-terracotta hover:text-terracotta"
            >
              {t.footer.admin}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
